var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_178_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0418 4.16659C13.8557 4.32539 14.6038 4.72347 15.1902 5.30986C15.7766 5.89626 16.1746 6.64431 16.3334 7.45825M13.0418 0.833252C14.7328 1.02112 16.3098 1.7784 17.5136 2.98076C18.7175 4.18312 19.4768 5.75909 19.6668 7.44992M18.8334 14.0999V16.5999C18.8344 16.832 18.7868 17.0617 18.6939 17.2744C18.6009 17.487 18.4645 17.6779 18.2935 17.8348C18.1225 17.9917 17.9206 18.1112 17.7007 18.1855C17.4809 18.2599 17.2479 18.2875 17.0168 18.2666C14.4525 17.988 11.9893 17.1117 9.82511 15.7083C7.81163 14.4288 6.10455 12.7217 4.82511 10.7083C3.41676 8.53426 2.54031 6.05908 2.26677 3.48325C2.24595 3.25281 2.27334 3.02055 2.34719 2.80127C2.42105 2.58199 2.53975 2.38049 2.69575 2.2096C2.85174 2.03871 3.04161 1.90218 3.25327 1.80869C3.46492 1.7152 3.69372 1.6668 3.92511 1.66659H6.42511C6.82953 1.6626 7.2216 1.80582 7.52824 2.06953C7.83488 2.33324 8.03517 2.69946 8.09177 3.09992C8.19729 3.89997 8.39298 4.68552 8.67511 5.44159C8.78723 5.73986 8.81149 6.06401 8.74503 6.37565C8.67857 6.68729 8.52416 6.97334 8.30011 7.19992L7.24177 8.25825C8.42807 10.3445 10.1555 12.072 12.2418 13.2583L13.3001 12.1999C13.5267 11.9759 13.8127 11.8215 14.1244 11.755C14.436 11.6885 14.7602 11.7128 15.0584 11.8249C15.8145 12.107 16.6001 12.3027 17.4001 12.4083C17.8049 12.4654 18.1746 12.6693 18.4389 12.9812C18.7032 13.2931 18.8436 13.6912 18.8334 14.0999Z",
    stroke: "#25282B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.328f2e27653ee3159a6608f0e47b63ed.svg";
export { ForwardRef as ReactComponent };